export { default as ListarPlanillas } from './Listar'
export { default as CrearPagoPlanilla  } from './Crear'
export { default as EdicionBonosPlanilla  } from './editarbonos'
export { default as DetallePlanilla } from './detalle'